import {BaseConfig} from "../../infrastructure/config/base-config";
import {ScoreboardWidgetTerms} from "./scoreboard-widget.terms";

export class ScoreboardWidgetConfig extends BaseConfig {

  static injectables = [ScoreboardWidgetTerms];

  constructor(terms: ScoreboardWidgetTerms) {
    super('scoreboardWidget', null, terms);
  }
}
